

const sanitizeExcelName = (value, fallback = "Proyecto", max = 31) => {
  return String(value || fallback)
    .trim()
    .substring(0, max);
};

const getHeaders = () => [
  "Id",
  "Funcionalidad",
  "Caso de Prueba",
  "Descripción",
  "Número de Paso",
  "Acción a Realizar",
  "Resultado Esperado",
];

const setWorksheetColumns = (worksheet) => {
  worksheet.columns = [
    { width: 8 },
    { width: 22 },
    { width: 36 },
    { width: 52 },
    { width: 18 },
    { width: 42 },
    { width: 50 },
  ];
};

const applyHeaderStyle = (worksheet) => {
  worksheet.addRow(getHeaders());

  const row = worksheet.getRow(1);

  row.eachCell(cell => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "1F5A99" },
    };
    cell.font = {
      color: { argb: "FFFFFFFF" },
      bold: true,
      size: 11,
    };
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: false,
    };
    cell.border = {
      top: { style: "thin", color: { argb: "FFFFFFFF" } },
      left: { style: "thin", color: { argb: "FFFFFFFF" } },
      bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
      right: { style: "thin", color: { argb: "FFFFFFFF" } },
    };
  });
};

const applyRowStyle = (row) => {
  row.eachCell(cell => {
    cell.alignment = {
      vertical: "top",
      horizontal: "left",
      wrapText: false,
    };
    cell.border = {
      top: { style: "thin", color: { argb: "D9D9D9" } },
      left: { style: "thin", color: { argb: "D9D9D9" } },
      bottom: { style: "thin", color: { argb: "D9D9D9" } },
      right: { style: "thin", color: { argb: "D9D9D9" } },
    };
  });
};

const addSeparatorRow = (worksheet) => {
  const separatorRow = worksheet.addRow(["", "", "", "", "", "", ""]);
  separatorRow.height = 14;

  separatorRow.eachCell({ includeEmpty: true }, cell => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "1F5A99" },
    };
    cell.border = {
      top: { style: "thin", color: { argb: "FFFFFFFF" } },
      left: { style: "thin", color: { argb: "FFFFFFFF" } },
      bottom: { style: "thin", color: { argb: "FFFFFFFF" } },
      right: { style: "thin", color: { argb: "FFFFFFFF" } },
    };
  });
};

const addTestCaseRows = (worksheet, tc, index = 0, separator = false) => {
  if (separator) {
    addSeparatorRow(worksheet);
  }

  const caseId = String(tc.id || index + 1).padStart(3, "0");
  const steps = Array.isArray(tc.steps) ? tc.steps : [];

  console.log("Son stepsss",steps)

  if (!steps.length) {
    const row = worksheet.addRow([
      caseId,
      tc.funcionalidad || "",
      tc.title || "",
      tc.description || "",
      "Paso 1",
      "",
      "",
    ]);
    applyRowStyle(row);
    return;
  }

  steps.forEach((step, i) => {
    const row = worksheet.addRow([
      i === 0 ? caseId : "",
      i === 0 ? tc.funcionalidad || "" : "",
      i === 0 ? tc.title || "" : "",
      i === 0 ? tc.description || "" : "",
      `Paso ${i + 1}`,
      step.action || "",
      step.expected || "",
    ]);
    applyRowStyle(row);
  });
};

const applyWorksheetExtras = (worksheet) => {
  worksheet.views = [{ state: "frozen", ySplit: 1 }];

  worksheet.autoFilter = {
    from: "A1",
    to: "G1",
  };
};

const download = async (workbook, fileName) => {
  const safeFileName = sanitizeExcelName(fileName, "archivo", 80);
  const buffer = await workbook.xlsx.writeBuffer();

  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${safeFileName}.xlsx`;
  link.click();

  URL.revokeObjectURL(link.href);
};

export const exportMultipleCases = async (cases, projectName) => {
  const ExcelJS = (await import (/* webpackChunkName: "exceljs" */ 'exceljs')).default
  const workbook = new ExcelJS.Workbook();
  const sheetName = sanitizeExcelName(`TC-${projectName}`);
  const worksheet = workbook.addWorksheet(sheetName);

  applyHeaderStyle(worksheet);
  setWorksheetColumns(worksheet);
  applyWorksheetExtras(worksheet);

  cases.forEach((tc, index) => {
    addTestCaseRows(worksheet, tc, index, index > 0);
  });

  await download(workbook, sheetName);
};

export const exportSingleCase = async (tc, projectName) => {
  const ExcelJS = (await import (/* webpackChunkName: "exceljs" */ 'exceljs')).default
  const workbook = new ExcelJS.Workbook();
  const sheetName = sanitizeExcelName(`TC-${projectName}`);
  const worksheet = workbook.addWorksheet(sheetName);

  applyHeaderStyle(worksheet);
  setWorksheetColumns(worksheet);
  applyWorksheetExtras(worksheet);
  addTestCaseRows(worksheet, tc);

  await download(workbook, tc.title || "caso");
};